import TrainingSubscription from '../subscription';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSubscription.destroy(({ trainingId, subscriptionId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/subscriptions/${subscriptionId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };